import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/prana-club-new/prana-club-new/.build/app/src/app/(app)/[lng]/components/home/home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloGlobalSeed"] */ "/home/runner/work/prana-club-new/prana-club-new/.build/app/src/shared/libs/apollo/apollo-global-seed.tsx");
